module.exports = __webpack_public_path__ + "img/bckarw.e46700fe.svg";